import { Type } from "@angular/core";

export interface Configuration {
  context?: string,
  feature: ConfigurationFeature | string,
  component?: Type<any>,
  enabled: boolean,
  properties?: any
}

export enum ConfigurationFeature {
  DOCUMENT_INGESTION="DOCUMENT_INGESTION",
  LEM="LEM",
  DASHBOARD="DASHBOARD",
  PROTOCOL = "PROTOCOL",
  OCR = "OCR",
  SIGN_DOCUMENT = "SIGN_DOCUMENT",
  JUSTICE_PDA = "JUSTICE_PDA",
  JUSTICE_PDA_SCHEDULE_AUTOIMPORT = "JUSTICE_PDA_SCHEDULE_AUTOIMPORT",
  EXPORT = "EXPORT",
  PCT = "PCT",
  MASSIVE_DOWNLOAD_DOCUMENT = "MASSIVE_DOWNLOAD_DOCUMENT"
}
